function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "Woman");

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M76.4,40c0,10.6-8.6,19.1-19.1,19.1c-10.6,0-19.1-8.6-19.1-19.1c0-10.6,8.6-19.1,19.1-19.1C67.8,20.9,76.4,29.4,76.4,40   L76.4,40z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M83.6,71.7c0-5.4-5.3-9.7-11.8-9.7H43.1c-6.5,0-11.8,4.3-11.8,9.7l-16.1,59.8c0,5.4,5.3,9.7,11.8,9.7h10.4V172   c0,5,4,9,8.9,9c4.9,0,8.9-4,8.9-9v-30.9h4V172h0c0,5,4,9,8.9,9s8.9-4,8.9-9v-30.9h10.8c6.5,0,11.8-4.3,11.8-9.7L83.6,71.7z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    version: 1.1,
    id: "Layer_2",
    viewBox: "0 0 200 200"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/Woman.df6259b7.svg";
export { SvgComponent as ReactComponent };